import * as React from 'react';
import FieldsLabel from './FieldsLabel';
import { twMerge } from 'tailwind-merge';

export const formClasses =
  'block w-full appearance-none rounded-lg border border-gray-200 bg-white py-[calc(theme(spacing.2)-1px)] px-[calc(theme(spacing.3)-1px)] text-gray-900 placeholder:text-gray-400 focus:border-lightPrimary focus:outline-none focus:ring-lightPrimary sm:text-sm';

export interface TextInputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  id: string;
  label?: string;
  type?: React.HTMLInputTypeAttribute;
  isValid?: boolean;
  isInvalid?: boolean;
  className?: string;
}

export function TextInput({
  id,
  label,
  type = 'text',
  isValid,
  isInvalid,
  className,
  ...props
}: TextInputProps) {
  return (
    <div className={className}>
      {label && (
        <FieldsLabel id={id} className={twMerge(isInvalid && 'text-red-600')}>
          {label}
        </FieldsLabel>
      )}
      <input
        id={id}
        type={type}
        {...props}
        className={twMerge(
          formClasses,
          isValid && 'border-success focus:border-success focus:ring-success',
          isInvalid && 'border-error focus:border-error focus:ring-error',
        )}
      />
    </div>
  );
}
